var map = {
	"./AgendaIcon.vue": 43436,
	"./AlertCircleIcon.vue": 80302,
	"./ArrowRightIcon.vue": 59687,
	"./BugFixIcon.vue": 18461,
	"./CalendarIcon.vue": 39687,
	"./ChevronDownIcon.vue": 88042,
	"./ChevronLeftIcon.vue": 30038,
	"./ChevronRightIcon.vue": 16495,
	"./ChevronUpIcon.vue": 62805,
	"./CircleCheckIcon.vue": 25004,
	"./CircleXIcon.vue": 63727,
	"./DangerSignIcon.vue": 40821,
	"./DashboardIcon.vue": 15898,
	"./DocumentIcon.vue": 19864,
	"./DotsIcon.vue": 12025,
	"./DownloadActiveIcon.vue": 37475,
	"./DownloadIcon.vue": 84597,
	"./EyeIcon.vue": 75802,
	"./EyeOffIcon.vue": 35449,
	"./FileTextIcon.vue": 88217,
	"./FilterIcon.vue": 66576,
	"./FilterUpIcon.vue": 70601,
	"./HandshakeIcon.vue": 98843,
	"./ImprovementsIcon.vue": 43665,
	"./InfoCircleFullIcon.vue": 93235,
	"./InfoCircleIcon.vue": 61501,
	"./LockIcon.vue": 95199,
	"./MailIcon.vue": 33485,
	"./MaintenanceIcon.vue": 1349,
	"./NewFeatureIcon.vue": 86358,
	"./NotificationsActiveIcon.vue": 40435,
	"./NotificationsIcon.vue": 13627,
	"./PencilIcon.vue": 35112,
	"./PieChartIcon.vue": 61835,
	"./PlusIcon.vue": 57411,
	"./RefreshIcon.vue": 10272,
	"./ReportIcon.vue": 69386,
	"./SearchIcon.vue": 97464,
	"./SettingsIcon.vue": 42860,
	"./StarFullIcon.vue": 29556,
	"./StarIcon.vue": 90244,
	"./SuccessIcon.vue": 86916,
	"./TradeIcon.vue": 62346,
	"./TrainingIcon.vue": 11167,
	"./TrashIcon.vue": 72660,
	"./UpdatesActiveIcon.vue": 37268,
	"./UpdatesIcon.vue": 70771,
	"./UploadIcon.vue": 63700,
	"./UserIcon.vue": 7133,
	"./WalletIcon.vue": 859,
	"./XIcon.vue": 9882
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80421;